import { NativeModules, Platform } from 'react-native';

// The app shell reserves a 52-point header and space for native window buttons.
// Keep older native builds usable during a Metro refresh before rebuilding.
export const hasUnifiedMacTitlebar = Platform.OS === 'macos'
  && typeof NativeModules.MacMenuBridge?.setUnifiedTitlebar === 'function';
export const MAC_HEADER_HEIGHT = hasUnifiedMacTitlebar ? 52 : 48;
export const MAC_WINDOW_CONTROLS_WIDTH = hasUnifiedMacTitlebar ? 88 : 0;

// Full-window overlays replace the React navigation header, but AppKit's
// title bar still covers its top row. macOS safe-area-context reports zero
// there, so keep overlay controls below the native window controls.
export function getWindowOverlayTopInset(safeAreaTop = 0) {
  return Platform.OS === 'macos' && hasUnifiedMacTitlebar
    ? Math.max(safeAreaTop, MAC_HEADER_HEIGHT)
    : safeAreaTop;
}

export function setUnifiedMacTitlebar(enabled) {
  if (hasUnifiedMacTitlebar) NativeModules.MacMenuBridge.setUnifiedTitlebar(enabled);
}
